module.exports = __webpack_public_path__ + "images/point-start.png";